// React imports.
import React from "react";


// App imports.
import Assessment3Sup3TableRow from "./Assessment3Sup3TableRow";

const Assessment3Sup3Table = ({ state }) => (
    <div>
        
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel	</div>
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsServedByVendorsProvidingData === true &&		
            <div className="header"># of Households Represented by Vendors Providing Data	</div>
            }
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsDataReceived2 === true &&		
            <div className="header"># of Households for Whom Main Heating Data was Received	</div>
            }
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentRateOfReturn === true &&		
            <div className="header">Rate of Return for Vendors Submitting Data (%)	</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showRateOfReturnStatus === true &&		
            <div className="header">Rate of Return Status	</div>
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Electric.name)
                &&
                <Assessment3Sup3TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Electric.name )} state={state} fuel={state.Assessment3FuelTypesStatus.Electric} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.NaturalGas.name)
                &&
                <Assessment3Sup3TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.NaturalGas.name )} state={state} fuel={state.Assessment3FuelTypesStatus.NaturalGas} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.FuelOil.name)
                &&
                <Assessment3Sup3TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.FuelOil.name )} state={state} fuel={state.Assessment3FuelTypesStatus.FuelOil} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Propane.name)
                &&
                <Assessment3Sup3TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Propane.name )} state={state} fuel={state.Assessment3FuelTypesStatus.Propane} />
            }
        </div>
    </div>
);

export default Assessment3Sup3Table;
